// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/04bc66876efd28832136.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0b0beccb1012e4752aa3","135":"74c1f1a256061361d0a6","136":"6d89c80db16a401556b2"}[chunkId] + ".chunk.js";
};